import { Text, makeStyles, tokens } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { usePageStyles } from '../components/layout/pageStyles';

const useStyles = makeStyles({
  body: { color: tokens.colorNeutralForeground3, fontSize: tokens.fontSizeBase400 },
});

/**
 * Any path no route matches, including the retired `/export` (DP-CNV-EXPORT-ROUTE, ruled 2026-10-26). Before this an
 * unknown path rendered an empty shell: no failure state and nothing to click.
 */
export default function NotFoundPage() {
  const styles = useStyles();
  const frame = usePageStyles();
  const { t } = useTranslation();

  return (
    <div className={frame.page}>
      <Text as="h1" className={frame.title}>{t('notFound.title')}</Text>
      <Text className={styles.body}>{t('notFound.body')}</Text>
      <Link to="/">{t('notFound.home')}</Link>
    </div>
  );
}
